import api from "./axios";
import type {
  LogislyOrderTakerConfigV2,
  LogislyOrderTakerV2HistoryResponse,
} from "../types/logislyOrderTakerV2";

export type LogislyOrderTakerV2Payload = {
  logislyTruckId: string;
  logislyDriverId: string;
  muat: { id: string };
  bongkar: Array<{ id: string; priority: number }>;
  isMultidrop: boolean;
};

export const getLogislyOrderTakerV2OpenConfigsApi = async (): Promise<
  LogislyOrderTakerConfigV2[]
> => (await api.get("/api/v1/logisly/order-taker-configs-v2")).data.data.configs;
export const getLogislyOrderTakerV2HistoryApi = async (
  params: Record<string, string | number | undefined>,
): Promise<LogislyOrderTakerV2HistoryResponse> =>
  (await api.get("/api/v1/logisly/order-taker-configs-v2/history", { params })).data.data;
export const createLogislyOrderTakerV2ConfigApi = async (
  payload: LogislyOrderTakerV2Payload,
): Promise<LogislyOrderTakerConfigV2> =>
  (await api.post("/api/v1/logisly/order-taker-configs-v2", payload)).data.data.config;
export const moveLogislyOrderTakerV2PriorityApi = async (
  id: string,
  payload: { beforeConfigId?: string; afterConfigId?: string },
): Promise<LogislyOrderTakerConfigV2[]> =>
  (await api.put(`/api/v1/logisly/order-taker-configs-v2/${id}/priority`, payload)).data.data
    .configs;
export const cancelLogislyOrderTakerV2ConfigApi = async (
  id: string,
  reason = "Manual cancellation",
): Promise<LogislyOrderTakerConfigV2> =>
  (await api.post(`/api/v1/logisly/order-taker-configs-v2/${id}/cancel`, { reason })).data.data
    .config;
